(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name productes.permisos.controller:ProductesMainPermisosCtrl
   *
   * @description
   *
   */
  angular
    .module('itecAdministracio.productes.main.submain.permisos')
    .controller('ProductesMainPermisosCtrl', ProductesMainPermisosCtrl);

  function ProductesMainPermisosCtrl($window, $rootScope, HelperFactory, ItecTreeTracking, TemaFactory, Notification, $scope, $q, $state, $stateParams,producteData,ProducteFactory) {
      var vm = this;
      vm.ctrlName = 'ProductesMainPermisosCtrl';
      vm.producte=producteData.data;

      vm.children                 = [];
      vm.expandedCollection       = [];
      vm.loadChildren             = loadChildren;
      vm.treeTracking             = ItecTreeTracking.newInstance();
      vm.loadBasicTree            = loadBasicTree;
      vm.rootTreeNodeCollection   = [];
      vm.loadBasicTree();
      vm.back = back;
      vm.func= func;
      vm.errors = [];


      vm.onChangeReadTheme=onChangeReadTheme;
      vm.onChangeDeleteTheme=onChangeDeleteTheme;
      vm.onChangeEditTheme=onChangeEditTheme;
      vm.onChangeAddTheme=onChangeAddTheme;
      vm.actualitzarrols=actualitzarrols;

      function loadBasicTree(){
        ProducteFactory.gettemesvistesarrel(vm.producte.id).then(function(response) {
          $scope.$evalAsync(function(){
            if (response.data.temes.length > 0) {
              response.data.temes.forEach(function(elem){
                vm.rootTreeNodeCollection.push(elem);
                loadChildren(elem);
              });
            }
          });
        });
      }

      function filterNode(){
        return true;
      }

      function loadChildren(object) {
        if (object === undefined) {
          return [];
        }


        var deferred = $q.defer();
          if(object.children===null)
          {
            if (object.type === 'tema'){
              ProducteFactory.getfills(object.id,vm.producte.id).then(function(response){
                $scope.$evalAsync(function(){
                  object.children = response.data.temes.concat(response.data.objectes);
                  angular.forEach(object.children, function(obj, index){
                  if (obj.type === 'vista') {
                    vm.producte.vistes.push(obj);
                    }
                  });
                  deferred.resolve(object.children);
                });
              });
            }
        }
        else{
            deferred.resolve(object.children);
        }
        return deferred.promise;
      }




      function onChangeReadTheme(object)
      {
        if (object.read){
            vm.expandedCollection.push(object);
        }
        if (!angular.isUndefined(object.children) && object.children !== null){
          object.children.forEach(function(child){
            child.read = object.read;
            if (child.type === 'tema'){
              onChangeReadTheme(child);
            }
          });
        }
      }

 function onChangeAddTheme(object)
      {
        if (object.read){
            vm.expandedCollection.push(object);
        }
        if (!angular.isUndefined(object.children) && object.children !== null){
          object.children.forEach(function(child){
            child.add = object.add;
            if (child.type === 'tema'){
              onChangeAddTheme(child);
            }
          });
        }
      }

 function onChangeDeleteTheme(object)
      {
        if (object.read){
            vm.expandedCollection.push(object);
        }
        if (!angular.isUndefined(object.children) && object.children !== null){
          object.children.forEach(function(child){
            child.delete = object.delete;
            if (child.type === 'tema'){
              onChangeDeleteTheme(child);
            }
          });
        }
      }

 function onChangeEditTheme(object)
      {
        if (object.read){
            vm.expandedCollection.push(object);
        }
        if (!angular.isUndefined(object.children) && object.children !== null){
          object.children.forEach(function(child){
            child.edit = object.edit;
            if (child.type === 'tema'){
              onChangeEditTheme(child);
            }
          });
        }
      }


      function back() {
        $rootScope.$broadcast('productes.main.showOptionSubmenu', {'show': false});
        if ($stateParams.isNew) {
          $state.go('productes.main', $stateParams, {'reload': 'productes.main.submain'});
        }
        else {
          $state.go('productes.main.submain.dades', $stateParams, {'reload': 'productes.main.submain'});
        }
      }

      function func() {
        edit();
      }

      function edit() {
        ProducteFactory.updatevistes(vm.producte.id, vm.producte).then(function (response){
        $rootScope.$broadcast('productes.main.submain.permisos', vm.producte);
        $state.go('productes.main.submain.dades', $stateParams, {'reload': 'productes.main.submain.permisos'});
        }).catch(function(error){
          vm.errors = Notification.processError(error);
        });
      }

      function actualitzarrols() {
        $rootScope.$broadcast('$activateLoader');
        ProducteFactory.updaterols(vm.producte.id, vm.producte.id).then(function (response){
        $rootScope.$broadcast('$deactivateLoader');
        $rootScope.$broadcast('productes.main.submain.permisos', vm.producte);
        $state.go('productes.main.submain.dades', $stateParams, {'reload': 'productes.main.submain.permisos'});
        }).catch(function(error){
          $rootScope.$broadcast('$deactivateLoader');
          vm.errors = Notification.processError(error);
        });
      }

 }
}());
